import { render, staticRenderFns } from "./AutocreditResolveDialog.vue?vue&type=template&id=36f772f5&scoped=true&"
import script from "./AutocreditResolveDialog.vue?vue&type=script&lang=ts&"
export * from "./AutocreditResolveDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f772f5",
  null
  
)

export default component.exports